module.exports = __webpack_public_path__ + "img/旋转木马男孩.ea9bba13.png";